import React, { Component } from 'react';
import { Table, Input, Popconfirm, Button, Select } from 'antd';
import SearchRetrieve from '../../../common/SearchRetrieve.new';
import API_URL from '../../../../common/url';
import Fetch from '../../../../common/Fetch';
const Option = Select.Option;

class EditableCell extends Component {

    state = {
        List: [],
    }

    timer = null;

    handleChange = (value, type, customerCompanyId) => {
        const { List } = this.state;
        const option = List.find(i => i.customerCompanyUserId == value) || undefined;
        this.queryList(value, type, customerCompanyId);
        if (option) {
            this.props.onChange(option[type], option.customerCompanyUserId);
        } else {
            this.props.onChange(value, value);
        }
    }

    queryList = (value, type, customerCompanyId) => {
        clearTimeout(this.timer);
        this.timer = setTimeout(() => {
            Fetch.post(API_URL.contract.queryList, {
                userName: value,
                searchType: type,
                customerCompanyId,
            }).then(res => {
                const { data } = res;
                this.setState({
                    List: data,
                })
            })
        }, 300);
    }

    getContent = () => {
        const { type, value, customerCompanyId } = this.props;
        const { List } = this.state;
        const comboboxOptions = (List || []).map(el => <Option value={el.customerCompanyUserId}>{el[type]}</Option>)
        return (
            customerCompanyId &&
            <Select
                mode="combobox"
                placeholder='请选择'
                style={{ width: '110px' }}
                value={value}
                filterOption={false}
                onFocus={value => this.queryList(value, type, customerCompanyId)}
                onChange={value => this.handleChange(value, type, customerCompanyId)}
            >
                {comboboxOptions}
            </Select>
        )
    }

    render() {
        const { editable, value } = this.props;
        return (
            <div>
                {
                    editable ?
                        this.getContent()
                        :
                        value
                }
            </div>
        )
    }
}

class EditableTable extends Component {
    state = {
        dataSource: [],
    }

    handleChange = (value, id, key, idx) => {
        const { customerCompanyId } = this.props;
        let newData = [...this.props.dataSource];
        Fetch.post(API_URL.contract.queryList, {
            customerCompanyId,
        }).then(res => {
            const { data } = res;
            data.map(i => {
                const {userMail, userMobile, userName, address} = i;
                if (i.customerCompanyUserId == id) {
                    newData[idx].userMail = userMail ? userMail : undefined;
                    newData[idx].userMobile = userMobile ? userMobile : undefined;
                    newData[idx].userName = userName ? userName : undefined;
                    newData[idx].address = address ? address : undefined;
                }
            });
            const target = newData.find((item, index) => index === idx);
            if (target) {
                target[key] = value;
                this.props.onChange([...newData]);
            }
        })
    }

    cancel = (index) => {
        const newData = [...this.props.dataSource];
        newData.splice(index, 1);
        this.props.onChange([...newData]);
    }

    getColumns = () => {
        const { canEdit, columns, customerCompanyId } = this.props;
        const columnList = columns.map(item => {
            const { key, ...rest } = item;
            const params = {
                ...rest,
                key,
                dataIndex: key,
            };
            params.render = (text, record, index) => {
                const { editable } = record;
                return (
                    <EditableCell
                        customerCompanyId={customerCompanyId}
                        editable={canEdit && editable}
                        type={key}
                        value={text}
                        params={record}
                        onChange={(value, id) => this.handleChange(value, id, key, index)}
                    />
                )
            };
            return params;
        });
        if (canEdit) {
            columnList.push({
                title: '操作',
                key: 'operation',
                width: 60,
                render: (text, record, index) => {
                    return (
                        <Popconfirm title="确定要删除该行数据?" onConfirm={() => this.cancel(index)}>
                            <a>删除</a>
                        </Popconfirm>
                    )
                },
            });
        }
        return columnList;
    }

    handleAdd = () => {
        const { dataSource, onChange } = this.props;

        const len = (dataSource || []).length;
        const newData = {
            key: len,
            editable: true,
        };
        onChange([...dataSource, newData]);
    }

    render() {
        const { canEdit, btnText, scrollX, dataSource } = this.props;
        const scroll = { y: 200 };
        return (
            <div style={{ margin: '20px 0' }}>
                {canEdit && <Button onClick={this.handleAdd} style={{ marginBottom: 10 }}>{btnText}</Button>}
                <Table
                    bordered
                    loading={false}
                    pagination={false}
                    scroll={scroll}
                    columns={this.getColumns()}
                    dataSource={dataSource}
                    rowKey={record => record.key}
                />
            </div>
        )
    }
}

export default EditableTable;


// WEBPACK FOOTER //
// ./src/components/contractManagement/requestRecord/components/EditableTable.js